<template>
   <div class="row">
    <div class="courses-content Bold">
      <div class="coursesPC">
        <Breadcrumbs class="magazine-bread" ref="breadcrumbs"></Breadcrumbs>
        <innerTab></innerTab>
         
           <div class="coursesPC feature-story-inner">
          <div class="col-xs-12 col-sm-12 col-md-12 feature-story pad-0">
            <div class="col-xs-12 col-sm-6 col-md-3 feature-story-item"
              v-for="(item,index) in ArticleList"
              :key=index
              @click="goMagazineDetail(item)"
            >
              <div class="col-xs-12 col-sm-12 col-md-12 hot-picks-ad digital-marketing-ad hot-picks-adFeature">
                <!-- <div class="issue-tietle Regular" v-if="$store.state.innerWidth>992">
                   {{$t('message.Issue')}} {{item.issueNumber}}
                </div> -->
                <div class="col-xs-6 col-sm-6 col-md-12 hot-picks-placeImg hot-picks-placeImgFeacture pad-0">
                  <img class="hot-picks-img" :src="$store.getters.getObject(item.langMap).coverPhoto" :alt="$store.getters.getObject(item.langMap).title" />
                  <div class="positive"></div>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-12 padLeft-0 padRight-0">
                  <div class="issue-tietle Regular">
                     {{$t('message.Issue')}} {{item.issueNumber}}
                  </div>
                  <div class="hot-picks-subtitle feacture-subtitle">{{$store.getters.getObject(item.subCategoryList[0].langMap).content}}</div>
                  <div class="hot-picks-information feacture-information">
                    <span class="hover-line feacture-hover-line">
                      <a href="javascript:;" style="color: inherit">{{$store.getters.getObject(item.langMap).title}}</a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            
           
          
          
        
         
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import { EventBus } from "@/javascripts/eventBus.js";
import innerTab from "@/components/innerTab";
export default {
  data() {
    return {
      // issueContent:{},
      featureStory: [],
      sideStory: [],
      column: [],
      categoryId:2,
      ArticleList:[],
        }
    },   
  props: ["magazineId"],
   components: {
    Breadcrumbs,
    innerTab
  },
  mounted() {
    // 
      this.$store.state.mate.title = this.$i18n.t("message.Online Magazine")+" - talent.gov.hk";
      this.$store.state.mate.description = this.$i18n.t("message.mateMagezine");
    this.$store.state.zi = 'Side Story'
    this.getArticleList();
   
  },
  methods: {
     goMagazineDetail: function(item) {
    
      this.$router.push({
        path:"/onlineMagazineDetail/" + item.id, 
        query:{
          lang:this.$store.state.language,
          name:this.$store.getters.replaceEvent(this.$store.getters.getObject(item.langMap).title)
        }
      });
    },
     getArticleList: function() {
      let that = this;
      
      that.api.getArticleList({categoryId: that.categoryId,startRow: 0,maxRows: 100000,}, function(data) {
        // 
        that.ArticleList = data.result;

      });
    },
    
  },
  watch: {
 
  }
};
</script>